import { render, staticRenderFns } from "./RelationTree.vue?vue&type=template&id=66104173&scoped=true"
import script from "./RelationTree.vue?vue&type=script&lang=js"
export * from "./RelationTree.vue?vue&type=script&lang=js"
import style0 from "./RelationTree.vue?vue&type=style&index=0&id=66104173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66104173",
  null
  
)

export default component.exports